import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { FreezePage } from '@/pages/freeze';

import { FreezeV2Page } from './index';

export const FreezeRoute = () => {
  const freezeV2 = useFeatureFlag('freeze_app_v2');
  return freezeV2 ? <FreezeV2Page /> : <FreezePage />;
};
